// @ts-nocheck

import { createSelector } from 'reselect';

import { getOutcomesFromProps } from '../../selectors/_propsGetters_';
import { type OutcomeStatus } from '../../types/history';
import { type Selector } from '../../types/selectors';

type OutcomeNbByStatusType = {
  [index: OutcomeStatus]: number;
};

type HistoryItemOutcomesSummaryPropsType = {
  outcomeNbByStatus: OutcomeNbByStatusType | null;
};

const selectOutcomeNbByStatus: Selector<OutcomeNbByStatusType | null> = createSelector(
  [(state) => state, getOutcomesFromProps],
  (state, outcomes) => {
    if (outcomes.length < 2) {
      return null;
    }

    const outcomeNbByStatus = {};

    outcomes.forEach(({ status }) => {
      if (status) {
        if (outcomeNbByStatus[status]) {
          outcomeNbByStatus[status]++;
        } else {
          outcomeNbByStatus[status] = 1;
        }
      }
    });

    return outcomeNbByStatus;
  },
);

const selectHistoryItemOutcomesSummaryProps: Selector<HistoryItemOutcomesSummaryPropsType> = createSelector(
  [selectOutcomeNbByStatus],
  (outcomeNbByStatus) => ({
    outcomeNbByStatus,
  }),
);

export default selectHistoryItemOutcomesSummaryProps;
